import { POWER_ZERO } from "../../../../../modules/EcommContent/ContactLensesEcommContent/constants.js";
import { isWithoutRx } from "../../../../../../components/RxableSelect/modules/EcommContent/components/RxableSelect/is-rx-radio-selection.js";
import { getMaxSelectableQuantity } from "../../../../../utils/modules/EcommContent/ContactLensesEcommContent/utils/get-max-selectable-quantity.js";
const getActions = (dispatch) => {
  const updatePurchaseType = (purchaseType) => {
    dispatch({ type: "setPurchaseType", payload: { purchaseType } });
    dispatch({ type: "resetErrors" });
  };
  const updatePrescriptionAttribute = (eyeSide, attribute, value) => {
    const payload = { eyeSide, attribute, value };
    dispatch({ type: "setPrescriptionAttribute", payload });
    dispatch({
      type: "updateStockStatus",
      payload: {
        eyeSide,
        stockIndicatorStatus: void 0,
        availableQuantity: void 0,
        allowBackOrder: void 0
      }
    });
    dispatch({ type: "resetFetchedSku", payload: { eyeSide } });
  };
  const updateSelectedQuantity = (eyeSide, quantity) => {
    dispatch({ type: "setSelectedQuantity", payload: { eyeSide, quantity } });
  };
  const updateTotalQuantity = (totalQuantity) => {
    dispatch({ type: "setTotalQuantity", payload: { totalQuantity } });
  };
  const resetTotalQuantity = () => {
    dispatch({ type: "resetTotalQuantity" });
  };
  const updateColumnCheckbox = (eyeSide, isEnabled) => {
    dispatch({ type: "setColumnCheckbox", payload: { eyeSide, isEnabled } });
  };
  const updateDeliveryInterval = (deliveryInterval) => {
    dispatch({ type: "setDeliveryInterval", payload: { deliveryInterval } });
  };
  const updateRxToggleSelection = (rxToggle) => {
    dispatch({ type: "setRxToggleSelection", payload: { rxToggle } });
    if (isWithoutRx(rxToggle)) {
      dispatch({
        type: "setPrescriptionAttribute",
        payload: { eyeSide: "both", attribute: "power", value: POWER_ZERO }
      });
    }
  };
  const updateQueryResult = ({
    eyeSide,
    maxOrderableQuantity,
    ...result
  }) => {
    dispatch({ type: "setQueryLoading", payload: { eyeSide, loading: false } });
    if ("error" in result) {
      dispatch({
        type: "updateQueryError",
        payload: { eyeSide, error: result.error }
      });
      return;
    }
    const { sku, allowBackOrder, availableQuantity, stockIndicatorStatus } = result.prescriptionCLProduct;
    const maxSelectableQuantity = getMaxSelectableQuantity({
      allowBackOrder,
      availableQuantity,
      maxOrderableQuantity
    });
    dispatch({ type: "updateFetchedSku", payload: { eyeSide, sku } });
    dispatch({
      type: "updateStockStatus",
      payload: { eyeSide, stockIndicatorStatus, availableQuantity, allowBackOrder }
    });
    dispatch({ type: "updateQueryError", payload: { eyeSide, error: void 0 } });
    dispatch({ type: "updateMaxSelectableQuantity", payload: { eyeSide, maxSelectableQuantity } });
  };
  const triggerValidationErrors = () => {
    dispatch({ type: "triggerErrors" });
  };
  const setQueryLoading = ({ eyeSide, loading }) => {
    dispatch({ type: "resetFetchedSku", payload: { eyeSide } });
    dispatch({ type: "setQueryLoading", payload: { eyeSide, loading } });
  };
  return {
    setQueryLoading,
    triggerValidationErrors,
    updateColumnCheckbox,
    updateDeliveryInterval,
    updatePrescriptionAttribute,
    updatePurchaseType,
    updateQueryResult,
    updateRxToggleSelection,
    updateSelectedQuantity,
    updateTotalQuantity,
    resetTotalQuantity
  };
};
export {
  getActions
};
//# sourceMappingURL=actions.js.map
